import { GenericAction, GenericActionWithPayload } from "./action-types";
import { CountryCode } from "./country-types";
import { NutritionalInfo } from "./nutrition";
import { ComboSectionType, OptionsType } from "./option";

type ProductSchedule = {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  startsAt: string;
  endsAt: string;
};

type OneTimeProductSchedule = {
  id?: number;
  publishAt: string;
  expiresAt: string;
};

type Variant = {
  productId: number;
  name: string;
  imageUrl: string;
};

type FetchProductsType = {
  forceUpdate?: boolean;
};

type ProductsById = Record<string, Product>;

type Product = {
  id: number;
  calories: number;
  description: string;
  filterCategories: string[];
  filterOrder: number;
  imageUrl: string;
  name: string;
  totalRequiredSections?: number;
  nutritionalInformation: NutritionalInfo[];
  options: OptionsType[] | null;
  price: number;
  variations: Variant[];
  schedule: ProductSchedule[];
  oneTimeSchedule?: OneTimeProductSchedule | null;
  countryCode: CountryCode;
  countryCodes?: CountryCode[];
  allergenInformation: AllergensType;
  inStock?: boolean;
  sections?: ComboSectionType[];
  isSelected?: boolean;
  quantity?: number;
};

type MenuItem = {
  filterHeight: number;
  filterImageUrl: string;
  filterWidth: number;
  height: number;
  width: number;
  imageUrl: string;
  isCombo: boolean;
  product: Product;
};

type HeroItem = {
  id: number;
  type: string;
  productId?: number;
  title?: string;
  label?: string;
  imageUrl?: string;
  url?: string;
};

type Variation = {
  id: number;
  productId?: number;
  name: string;
  cost: number;
  imageUrl?: string;
  iconImage: string;
  isSelected: boolean;
  inStock: boolean;
};

type AllergensType = {
  egg: string;
  fish: string;
  milk: string;
  mustard: string;
  sesame: string;
  crustaceans: string;
  soy: string;
  gluten: string;
};

type ProductListAction = GenericAction<"PRODUCT_LIST">;
type ProductListStartAction = GenericAction<"PRODUCT_LIST_START">;
type ProductSetAction = GenericActionWithPayload<"PRODUCT_SET", Product[]>;

type ProductAction =
  | ProductSetAction
  | ProductListAction
  | ProductListStartAction;

type ProductsFetchStartAction = GenericAction<"PRODUCTS_FETCH_START">;
type ProductsFetchDoneAction = GenericActionWithPayload<
  "PRODUCTS_FETCH_DONE",
  MenuItem[]
>;

type MenuItemAction = ProductsFetchStartAction | ProductsFetchDoneAction;

export type {
  Product,
  ProductsById,
  Variation,
  MenuItem,
  HeroItem,
  FetchProductsType,
  ProductAction,
  MenuItemAction,
  ProductsFetchDoneAction,
  AllergensType,
  Variant,
};
